import { Component, Input } from "@angular/core";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";

@Component({
  selector: "app-reporting-view-link-renderer",
  template: `
    <div *ngIf="dataObj.show">
      <div
        *ngIf="dataObj.showAnalyst"
        class="analyst-link"
        title="View Analysts As-
published View"
      >
        <a routerLink="{{ dataObj.analystLink }}">
          <span class="link">ANALYST</span>
          <span class="analyst-icon">
            <va-icon
              *ngIf="dataObj.analystIcon"
              name="info-circle"
              title="View Analyst As 
Reported Only View"
            >
            </va-icon>
          </span>
        </a>
      </div>
      <div
        *ngIf="dataObj.showDashboard"
        class="dashboard-link"
        title="View Analysts Dashboard"
      >
        <a routerLink="{{ dataObj.dashboardLink }}" routerLinkActive="active">
          <span class="link">DASHBOARD</span>
        </a>
      </div>
    </div>
  `,
  styles: [
    `
      .analyst-link {
        background-color: #4169e1;
        color: #fff;
        padding-bottom: 2px;
        padding-top: 2px;
        padding-right: 5px;
        padding-left: 5px;
        margin-right: 5px;
        display: inline-block;
      }
      .dashboard-link {
        background-color: olivedrab;
        color: #fff !important;
        padding-bottom: 2px;
        padding-top: 2px;
        padding-right: 5px;
        padding-left: 5px;
        display: inline-block;
      }
      .link {
        color: #fff;
        font-size: 12px;
      }
      .analyst-icon {
        font-size: 10px;
        color: #fff;
        padding-left: 4px;
      }
      a:hover {
        color: #fff;
      }
    `,
  ],
})
export class ReportingViewLinkRendererComponent {
  @Input() dataObj: any;

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([infoCircle]);
  }
}
